import { AccessLevelE } from './../../../models/enums';
import { UserRoleE } from "../../../models/enums";
import { UserT } from "../../../models/models";

export const filterByRole = (itemRoles: UserRoleE[] | undefined, currentUser: UserT | undefined, isGlobalAdmin: boolean) => {
    return (
        ((itemRoles as UserRoleE[])?.some(role => role === currentUser.role))
        ||
        ((currentUser.accessLevel === AccessLevelE.GlobalAdmin) && isGlobalAdmin)
    );
};

export const filterPublicPages = (menuItem: any) => {
    return menuItem.name === 'About'
        || menuItem.name === 'Features'
        || menuItem.name === 'Process'
        || menuItem.name === 'Our Customers'
        || menuItem.name === 'Contact Us';
};